namespace GeniuzPOS.Inventory {
    export interface IcStockReturnInDtForm {
        Id: Serenity.IntegerEditor;
        LineItemNo: Serenity.IntegerEditor;
        SkuCode: Serenity.LookupEditor;
        ItemRemark: Serenity.StringEditor;
        UnitChange: Serenity.EnumEditor;
        PurUnit: Serenity.StringEditor;
        PurUnitPrice: Serenity.DecimalEditor;
        PurUnitRatio: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        CostValue: Serenity.DecimalEditor;
        UnitCost: Serenity.DecimalEditor;
        Remark: Serenity.StringEditor;
        GRRefFg: Serenity.StringEditor;
        GRLineId: Serenity.StringEditor;
    }

    export class IcStockReturnInDtForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.IcStockReturnInDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!IcStockReturnInDtForm.init)  {
                IcStockReturnInDtForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.LookupEditor;
                var w2 = s.StringEditor;
                var w3 = s.EnumEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(IcStockReturnInDtForm, [
                    'Id', w0,
                    'LineItemNo', w0,
                    'SkuCode', w1,
                    'ItemRemark', w2,
                    'UnitChange', w3,
                    'PurUnit', w2,
                    'PurUnitPrice', w4,
                    'PurUnitRatio', w4,
                    'Qty', w4,
                    'CostValue', w4,
                    'UnitCost', w4,
                    'Remark', w2,
                    'GRRefFg', w2,
                    'GRLineId', w2
                ]);
            }
        }
    }
}
